import type { MatchPerson } from '@uefadigital/panenka';
import { MatchPersonRole } from '@uefadigital/panenka';

const refereeOrder = [
  MatchPersonRole.REFEREE,
  MatchPersonRole.ASSISTANT_REFEREE_ONE,
  MatchPersonRole.ASSISTANT_REFEREE_TWO,
  MatchPersonRole.FOURTH_OFFICIAL,
  MatchPersonRole.VIDEO_ASSISTANT_REFEREE,
  MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE,
  MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_ONE,
  MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_TWO,
  MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_THREE,
] as MatchPersonRole[];

// hook function to sort referee in a specific order
export function useRefereeOrder(referees: MatchPerson[]) {
  const mainReferees = [...referees].filter((ref) => refereeOrder.includes(ref.role));
  const restReferees = [...referees].filter((ref) => !refereeOrder.includes(ref.role));

  const sortedReferee = [...mainReferees].sort((referee, nextReferee) => {
    return refereeOrder.indexOf(referee.role) - refereeOrder.indexOf(nextReferee.role);
  });

  const newRef = [...sortedReferee, ...restReferees].map((referee) => {
    const assistantRefereeTwo = referees.find((referee) => referee.role === MatchPersonRole.ASSISTANT_REFEREE_TWO);
    const assistantVideoRefereeTwo = referees.find(
      (referee) => referee.role === MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_TWO,
    );
    const assistantVideoRefereeThree = referees.find(
      (referee) => referee.role === MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_THREE,
    );

    if (referee.role === MatchPersonRole.ASSISTANT_REFEREE_ONE && assistantRefereeTwo) {
      return { ...referee, person: [referee.person, assistantRefereeTwo.person] };
    } else if (referee.role === MatchPersonRole.ASSISTANT_REFEREE_TWO) {
      return null;
    } else if (
      referee.role.includes(MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE) &&
      referee.role !== MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_ONE
    ) {
      return null;
    } else if (referee.role === MatchPersonRole.ASSISTANT_VIDEO_ASSISTANT_REFEREE_ONE) {
      return {
        ...referee,
        person: [referee.person, assistantVideoRefereeTwo?.person, assistantVideoRefereeThree?.person],
      };
    }
    return { ...referee, person: [referee.person] };
  });

  return newRef.filter((ref) => !!ref);
}
